/**
 * Shapes for the copy that is longer than a label: the glossary and the seven
 * tutorial lessons. Lesson *ids* are internal and identical in both languages;
 * only the words change.
 */

export interface GlossaryEntry {
  /** Stable id, never shown. */
  id: string;
  /** The word as a learner sees it in this language. */
  term: string;
  meaning: string;
}

/** The internal lesson ids, in teaching order. Never translated. */
export const LESSON_IDS = [
  "dasar",
  "ambil-buang",
  "chow",
  "pong",
  "kong",
  "menang-sendiri",
  "menang-dari-buangan",
] as const;

export type LessonId = (typeof LESSON_IDS)[number];

export interface LessonCopy {
  /** Numbered title, e.g. "1. Dasar Mahjong". */
  title: string;
  /** One line: what this lesson teaches. */
  objective: string;
  /** Short paragraphs shown before and while playing. */
  intro: string[];
  /** The concrete task, shown above the table. */
  goal: string;
  /** Contextual instruction from the coach for this lesson. */
  coach: string;
  /** Shown once the goal is reached. */
  success: string;
}

export interface LocaleContent {
  glossary: GlossaryEntry[];
  lessons: Record<LessonId, LessonCopy>;
}
